import { formatDateKey } from '@griply/utils';

// getCalendarEventDate serialises an all-day boundary as a local-midnight instant; the popup target takes a date key.
export const toEventPopupBoundary = (
  value: string | undefined,
  allDay: boolean,
): string | undefined => {
  if (!value || !allDay) {
    return value;
  }
  return formatDateKey(new Date(value));
};
